import { Range } from 'slate'
import {
    DomEditor,
  } from '@wangeditor/core'

export default class InsertVideoMenu {                      
    constructor() {
        this.title = '插入视频' // 自定义菜单标题
        this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>'// 可选
        this.tag = 'button'
    }
 
    // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
    getValue(editor) {                              // JS 语法
        return false
    }
 
    // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
    isActive(editor) {                    // JS 语法
        return false
    }
 
    // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
    isDisabled(editor) {                     // JS 语法
        const { selection } = editor
        if (selection == null) return true
        if (!Range.isCollapsed(selection)) return true // 选区非折叠，禁用

        const selectedElems = DomEditor.getSelectedElems(editor)
        const hasVoidOrPre = selectedElems.some(elem => {
        const type = DomEditor.getNodeType(elem)
        if (type === 'pre') return true
        if (type === 'list-item') return true
        if (editor.isVoid(elem)) return true
        return false
        })
        if (hasVoidOrPre) return true // void 或 pre ，禁用

        return false
    }
 
    // 点击菜单时触发的函数
    exec(editor, value) {                              // JS 语法
        if (this.isDisabled(editor)) return
        // editor.insertText(value) // value 即 this.value(editor) 的返回值
        // if(this.callback!=null){
        //     this.callback();
        // }
        editor.emit('on-select-video-material')
    }
}